var b = typeof global == "object" && global && global.Object === Object && global, s = typeof self == "object" && self && self.Object === Object && self, v = b || s || Function("return this")(), a = v.Symbol, f = Object.prototype, p = f.hasOwnProperty, y = f.toString, t = a ? a.toStringTag : void 0, j = Object.prototype.toString, c = a ? a.toStringTag : void 0;
function g(e) {
  return e == null ? e === void 0 ? "[object Undefined]" : "[object Null]" : c && c in Object(e) ? function(r) {
    var n = p.call(r, t), o = r[t];
    try {
      r[t] = void 0;
      var l = !0;
    } catch {
    }
    var u = y.call(r);
    return l && (n ? r[t] = o : delete r[t]), u;
  }(e) : function(r) {
    return j.call(r);
  }(e);
}
var O = /\s/, d = /^\s+/;
function S(e) {
  return e && e.slice(0, function(r) {
    for (var n = r.length; n-- && O.test(r.charAt(n)); ) ;
    return n;
  }(e) + 1).replace(d, "");
}
function i(e) {
  var r = typeof e;
  return e != null && (r == "object" || r == "function");
}
var h = /^[-+]0x[0-9a-f]+$/i, N = /^0b[01]+$/i, m = /^0o[0-7]+$/i, $ = parseInt;
function T(e) {
  if (typeof e == "number") return e;
  if (function(o) {
    return typeof o == "symbol" || function(l) {
      return l != null && typeof l == "object";
    }(o) && g(o) == "[object Symbol]";
  }(e)) return NaN;
  if (i(e)) {
    var r = typeof e.valueOf == "function" ? e.valueOf() : e;
    e = i(r) ? r + "" : r;
  }
  if (typeof e != "string") return e === 0 ? e : +e;
  e = S(e);
  var n = N.test(e);
  return n || m.test(e) ? $(e.slice(2), n ? 2 : 8) : h.test(e) ? NaN : +e;
}
export {
  g as b,
  i,
  v as r,
  T as t
};
//# sourceMappingURL=toNumber-DCDlkXWV.js.map
